import * as React from 'react';
import Layout from '../../layouts/Layout';
import JobAlerts from '../../components/JobAlerts/JobAlerts';
import PageIntroSection from '../../components/PageIntroSection/PageIntroSection';
import ImageHero2 from '../../components/ImageHero2/ImageHero2';

// @ts-ignore
import heroImage from '../../images/BelleTire-fist-bump.png';
import BestPeopleSection from '../../components/BestPeopleSection/BestPeopleSection';
import JobSearchForm from '../../components/JobSearchForm/JobSearchForm';
import { graphql, useStaticQuery } from 'gatsby';
import BenefitsCarousel from '../../components/BenefitsCarousel/BenefitsCarousel';

const BenefitsPage: React.FC = () => {
	const data = useStaticQuery(graphql`
		query {
			allSitePage {
				edges {
					node {
						pageContext
						id
					}
				}
			}
		}
	`);
	const menuItems = [
		{
			text: 'Home',
			href: '/',
			active: false
		},
		{
			text: 'Positions',
			href: '/search/',
			active: false
		},
		{
			text: 'Our Story',
			href: '/story/',
			active: false
		},
		{
			text: 'Military',
			href: '/military/',
			active: false
		},
		{
			text: 'Benefits',
			href: '/benefits/',
			active: false
		},
		{
			text: 'Training',
			href: '/training/',
			active: false
		},
		{
			text: 'Career Growth',
			href: '/career-growth/',
			active: false
		}
	];
	return (
		<Layout menuItems={menuItems} title={'Belle Tire Careers'} desc={''}>
			<ImageHero2
				overlay
				bgImage={heroImage}
				h1={'Premium Benefits to Keep Your Life Moving!'}
				h2={''}

			/>
			<PageIntroSection
				h2={'WE BELIEVE YOU DESERVE BETTER'}
				white
				pTags={[
					{
						text: 'At Belle Tire, we believe you deserve better, and that’s why we offer premium benefits to keep life moving for you and your family. Because when you’re part of a team that’s Changing Tires, you deserve benefits that change the game.'
					}
				]}
			/>
			<BenefitsCarousel />
			<JobAlerts />
			{/* <BestPeopleSection h2="We’re Not Your Ordinary Tire Shop. <br/> We’re Changing Tires." /> */}
			<JobSearchForm data={data} />
		</Layout>
	);
};

export default BenefitsPage;
